import { createReducer, field } from 'redux/shelf';
import { get, post, put, del } from 'redux/shelf/api';

export const actions = {
  fetchHistory: get`payments/history`(field('history')),
  fetchBalance: get`payments/current`(field('balance')),
  fetchBillingInfo: get`payments/billing-info`(field('billingInfo')),
  fetchProcessor: get`payments/processor`(field('processor')),
  processorConfirm: post`payments/processor/confirm`(),
};

export const reducer = createReducer(actions);
